import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../config";

export const loadDonationDashboard = createAsyncThunk(
  "donationDashboard/load",
  async (_, { rejectWithValue }) => {
    try {
      const result = await api.donationStats();
      return result.data.data;
    } catch (e) {
      return rejectWithValue(e.message);
    }
  }
);

export const donationDashboardSlice = createSlice({
  name: "donationDashboard",
  initialState: {
    loading: false,
    error: null,
    totalRequests: 0,
    requestsFulfilled: 0,
    totalDonationValue: 0,
    avgDonation: 0,
    pendingApproval: 0,
    reviewing: 0,
    approved: 0,
    denied: 0,
    cancelled: 0,
    byType: [],
    topLocations: [],
    bottomLocations: [],
    topOrganizations: [],
    monthlyData: [],
    locationMonthlyData: {},
    donationTypesMonthly: {},
    orgMonthlyData: {},
    monthKeys: [],
  },
  reducers: {},
  extraReducers: {
    [loadDonationDashboard.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [loadDonationDashboard.fulfilled]: (state, action) => {
      state.loading = false;
      Object.assign(state, action.payload);
    },
    [loadDonationDashboard.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export default donationDashboardSlice.reducer;
